<template lang="pug">
.container(id="DeleteExtensionsForm-container")
  h4 {{$t('Delete Unused Extensions')}}
  hr.header
  p.error(v-if='errors.length > 0')
    span {{ errors[0].response.data }}.
  .existing-extension-section(v-if='exisitingExtensions.length > 0')
    p.advice(id="DeleteExtensionsForm-unusedExtensionsInfo")
      span {{ $t('Unused extensions.')}}
      span(v-if='selectedExtensions.length > 0') &nbsp;{{ selectedExtensions.length }} {{ $t(' selected.')}}
  .existing-extension-section(v-else)
    p.advice(id="DeleteExtensionsForm-noUnusedExtensionsInfo")
      span {{ $t('All extensions are in use :)')}}
  .existing-extension-section(v-if='exisitingExtensions.length > 0')
    .existing-extension-row
      .cell.header.name {{ $t('Name')}}
      .cell.header.version {{ $t('Version')}}
      .cell.header.description {{ $t('Description')}}
      .cell.header.global {{ $t('Global/Network')}}
  .existing-extension-section(v-if='exisitingExtensions.length > 0')
    .existing-extension-row(
      v-for='exisitingExtension of exisitingExtensions',
      :key='exisitingExtension.id',
      @click="toggleExtensionSelected(exisitingExtension)",
      :class="{ 'isSelected': selectedExtensions.find(ext => ext.id === exisitingExtension.id) }",
      :id="'DeleteExtensionsForm-extensionRow' + exisitingExtension.id"
    )
      .cell.name {{ exisitingExtension.name }}
      .cell.version {{ exisitingExtension.version }}
      .cell.description {{ exisitingExtension.description }}
      .cell.global
        font-awesome-icon(v-if='exisitingExtension.Network < 1', icon="globe")
        span(v-else) {{ exisitingExtension.networkName }}
  .delete-button-row
    el-button(id="DeleteExtensionsForm-submitDeleteButton" size='small', type='success', @click='submitDelete', :disabled='selectedExtensions.length === 0')
      span {{ uploading ? $t('deleting...') : $t('delete')}} &nbsp;
      font-awesome-icon(icon="trash")
  </template>

<script>
import Vue from 'vue'
import testUtils from './../Common/textUtils.mixin'

export default {
  mixins: [testUtils],
  props: ['side', 'folder'],
  async created () {
    this.exisitingExtensions = (await Vue.axios.get(`extension/findUnused`)).data
  },
  data () {
    return {
      uploadUrl: this.apiUrl('file/extensionUpload'),
      file: null,
      errors: [],
      uploading: false,
      exisitingExtensions: [],
      selectedExtensions: []
    }
  },
  watch: {
    params: async function (newParams, oldParams) {
    }
  },
  methods: {
    toggleExtensionSelected (extension) {
      const index = this.selectedExtensions.findIndex(ext => ext.id === extension.id)
      if (index === -1) {
        this.selectedExtensions.push(extension)
      } else {
        this.selectedExtensions.splice(index, 1)
      }
    },
    async submitDelete () {
      for (const selectedExtension of this.selectedExtensions) {
        await Vue.axios.post('extension/deleteUnused', { 'extensionId': selectedExtension.id })
          .then(response => {
            return response.data
          })
        console.log(selectedExtension.id)
      }
      this.exisitingExtensions = (await Vue.axios.get(`extension/findUnused`)).data
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.delete-button-row {
  border: 0px dotted pink;
  text-align: right;
  margin: 30px 0px -20px 0px;
  width: 1205px;
}
.error {
  color: $--color-warning;
}
.existing-extension-section {
  display: flex;
  align-items: center;
  flex-direction: column;
  .advice {
    color: $--color-text-secondary;
  }
  .existing-extension-row {
    display: flex;
    min-height: 30px;
    align-items: center;
    border-bottom: $--border-light;
    &.isSelected {
      background-color: $--background-color-selected;
    }
    .cell {
      font-size: $--font-size-base;
      padding: 10px;
      &.header {
        color: $--color-text-secondary;
      }
      &.name {
        width: 160px;
      }
      &.description {
        width: 750px;
      }
      &.version {
        width: 50px;
      }
      &.global {
        width: 150px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/DeleteExtensionsForm.vue